































import Vue from 'vue'
import ConfirmDialog from '@/components/elements/ConfirmDialog.vue'
import { LinkElInterface } from '@/config/interfaces'
import { darkColors, lightColors } from '@/config/colors'
import Utils from '@/helpers/Utils'

export default Vue.extend({
  name: 'LinkEl',

  components: { ConfirmDialog },

  data: () => ({
    showPopup: false
  }),

  computed: {
    hasPopup (): boolean {
      return !!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'confirmDialog')
    },
    linkDefaultColor (): string {
      return (this.$vuetify.theme.dark ? darkColors.secondary : lightColors.primary)
    }
  },
  methods: {
    getInputRefs (): URLSearchParams | null {
      if (!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'inputReferences')) {
        return null
      }
      const refs = this.templateItemData.inputReferences
      return Utils.getPostParamsByRefs(refs)
    }
  },
  props: {
    templateItemData: {
      type: Object as () => LinkElInterface,
      required: true
    }
  }
})
